const invoiceTypes = [
	{value: 1, label: 'Bireysel'},
	{value: 2, label: 'Kurumsal'},
]

export default invoiceTypes;